import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    theme: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOn: false,
    };
  },
  computed: {
    ...mapGetters('dashboard', ['mySharesCount']),
    classModifiers() {
      return {
        'dashboard-markets-toggle': true,
        [`dashboard-markets-toggle--${this.theme}`]: this.theme,
      };
    },
    buttonText() {
      return this.isOn ? 'Close All' : 'Open All';
    },
  },
  methods: {
    ...mapActions('dashboard', ['setMarketsToggle']),
    onClick() {
      this.isOn = !this.isOn;
      this.setMarketsToggle(this.isOn);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard-markets-toggle/dashboard-markets-toggle.js